import { atom } from 'jotai';

export const isColorSelectFailedNotificationOpenAtom = atom(false);
